import React from 'react'
import PropTypes from 'prop-types'
import { MinistriesPageTemplate } from '../../templates/ministries-page'
import { HTMLContent } from '../../components/Content'

const MinistriesPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <MinistriesPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        firstMinistry={data.firstMinistry}
        firstMinsitryTitle={data.firstMinsitryTitle}
        firstMinistryInfo={data.firstMinistryInf}
        secondMinistry={data.secondMinistry}
        secondMinsitryTitle={data.secondMinsitryTitle}
        secondMinistryInfo={data.secondMinistryInf}
        thirdMinistry={data.thirdMinistry}
        thirdMinsitryTitle={data.thirdMinsitryTitle}
        thirdMinistryInfo={data.thirdMinistryInf}
        fourthMinistry={data.fourthMinistry}
        fourthMinsitryTitle={data.fourthMinsitryTitle}
        fourthMinistryInfo={data.fourthMinistryInf}
        fifthMinistry={data.fifthMinistry}
        fifthMinsitryTitle={data.fifthMinsitryTitle}
        fifthMinistryInfo={data.fifthMinistryInf}
        sixthMinistry={data.sixthMinistry}
        sixthMinsitryTitle={data.sixthMinsitryTitle}
        sixthMinistryInfo={data.sixthMinistryInf}
        seventhMinistry={data.seventhMinistry}
        seventhMinsitryTitle={data.seventhMinsitryTitle}
        seventhMinistryInfo={data.seventhMinistryInf}
        eighthMinistry={data.eighthMinistry}
        eighthMinsitryTitle={data.eighthMinsitryTitle}
        eighthMinistryInfo={data.eighthMinistryInf}
        ninthMinistry={data.ninthMinistry}
        ninthMinsitryTitle={data.ninthMinsitryTitle}
        ninthMinistryInfo={data.ninthMinistryInf}
        tenthMinistry={data.tenthMinistry}
        tenthMinsitryTitle={data.tenthMinsitryTitle}
        tenthMinistryInfo={data.tenthMinistryInf}
        contentComponent={HTMLContent}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

MinistriesPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  contentComponent: PropTypes.func,
}

export default MinistriesPagePreview
